"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _require = require("./internal-constants"),
    domSymbolTree = _require.domSymbolTree;

var _require2 = require("../node-type"),
    DOCUMENT_NODE = _require2.DOCUMENT_NODE;

var _require3 = require("./namespaces"),
    HTML_NS = _require3.HTML_NS; // All these operate on and return impls, not wrappers!


exports.closest = function (e, localName) {
  while (e) {
    if (e.localName === localName && e.namespaceURI === HTML_NS) {
      return e;
    }

    e = domSymbolTree.parent(e);
  }

  return null;
};

exports.isConnected = function (node) {
  while (node) {
    if (node.nodeType === DOCUMENT_NODE) {
      return true;
    }

    node = domSymbolTree.parent(node);
  }

  return false;
};

exports.childrenByHTMLLocalName = function (parent, localName) {
  return domSymbolTree.childrenToArray(parent, {
    filter: function filter(node) {
      return node._localName === localName && node._namespaceURI === HTML_NS;
    }
  });
};

exports.descendantsByHTMLLocalName = function (parent, localName) {
  return domSymbolTree.treeToArray(parent, {
    filter: function filter(node) {
      return node._localName === localName && node._namespaceURI === HTML_NS && node !== parent;
    }
  });
};

exports.childrenByHTMLLocalNames = function (parent, localNamesSet) {
  return domSymbolTree.childrenToArray(parent, {
    filter: function filter(node) {
      return localNamesSet.has(node._localName) && node._namespaceURI === HTML_NS;
    }
  });
};

exports.descendantsByHTMLLocalNames = function (parent, localNamesSet) {
  return domSymbolTree.treeToArray(parent, {
    filter: function filter(node) {
      return localNamesSet.has(node._localName) && node._namespaceURI === HTML_NS && node !== parent;
    }
  });
};

exports.firstChildWithHTMLLocalName = function (parent, localName) {
  var iterator = domSymbolTree.childrenIterator(parent);

  var _iterator = _createForOfIteratorHelper(iterator),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var child = _step.value;

      if (child._localName === localName && child._namespaceURI === HTML_NS) {
        return child;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return null;
};

exports.firstChildWithHTMLLocalNames = function (parent, localNamesSet) {
  var iterator = domSymbolTree.childrenIterator(parent);

  var _iterator2 = _createForOfIteratorHelper(iterator),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var child = _step2.value;

      if (localNamesSet.has(child._localName) && child._namespaceURI === HTML_NS) {
        return child;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return null;
};

exports.firstDescendantWithHTMLLocalName = function (parent, localName) {
  var iterator = domSymbolTree.treeIterator(parent);

  var _iterator3 = _createForOfIteratorHelper(iterator),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var descendant = _step3.value;

      if (descendant._localName === localName && descendant._namespaceURI === HTML_NS) {
        return descendant;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return null;
};